/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import { Formik } from "formik";
import React from "react";
import Button from "../../../../../components/common/Button";
import Modal from "../../../../../components/common/Modal/Modal";
import InputField from "../../../../../components/common/new/InputField/InputField";
import styles from "./EditStructure.styles";
import Typography from "../../../../../components/common/new/Typography/Typography";

function EditStructure({ open, onClose, onFormSubmit, selectedStructure }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      customStyle={{ maxHeight: "95%", maxWidth: "95%", overflow: "scroll" }}
    >
      <Box style={styles.container}>
        <Typography variant="title1" weight={700} color="black" mb={4}>
          Edit Structure
        </Typography>
        <Formik
          onSubmit={onFormSubmit}
          initialValues={{
            structureName: selectedStructure?.structureName,
            totalMembersCount: selectedStructure?.totalMembersCount,
          }}
        >
          {({ handleChange, values, handleSubmit }) => (
            <form onSubmit={handleSubmit} style={styles.formContainer}>
              <InputField
                name="structureName"
                onChange={handleChange}
                placeholder="Structure Name"
                value={values.structureName}
                required
              />
              <InputField
                name="totalMembersCount"
                onChange={handleChange}
                placeholder="Total members"
                value={values.totalMembersCount}
              />
              <Box style={styles.actionButtons}>
                <Button label="Submit" type="submit" />
                <Button label="Cancel" variant="outlined" onClick={onClose} />
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

export default EditStructure;
